export function setConfigAndManRunnFlag(Program) {
  let configured = false
  if( Program.steps ) {
    Program.steps.forEach((item, index) => {
      if(item.runtime !== '')
        configured = true
    })
  }
  return configured
}

export function setActiveFlag(Program) {
  let runtime = false
  let starttime = false
  let active = false
  if( Program.steps ) {
    Program.steps.forEach((item, index) => {
      if(item.runtime !== '')
        runtime = true
    })
  }
  if( ! Program.starts ) {
    console.error( 'Program.starts not defined' )
  } else {
    Program.starts.forEach((item, index) => {
      if(item.starttime !== '')
        starttime = true
    })
  }
  if(starttime === true && runtime === true)
    active = true

  return active
}

export function setAutoRunnableFlag(Program) {
  let runtime = false
  let autoRunnable = false
  let starttime = false
  if( Program.steps ) {
    Program.steps.forEach((item, index) => {
      if(item.runtime !== '')
        runtime = true
    })
  }
  if( ! Program.starts ) {
    console.error( 'Program.starts not defined' )
  } else {
    Program.starts.forEach((item, index) => {
      if(item.starttime !== '')
        starttime = true
    })
  }
  if(starttime === true && runtime === true)
    autoRunnable = true

  return autoRunnable
}

export function addPrgConfig(program) {
  let nextRunConverted
  let temp

  if (typeof program.nextRun === 'string') {
    temp = program.nextRun.indexOf('M')
  } else if (typeof program.nextRun === 'number') {
    temp = program.nextRun
  } else {
    temp = -1
  }

  if (program.nextRun === '') {
    nextRunConverted = ''
  } else if (temp === -1) {
    nextRunConverted = 'N/A'
  } else if (program.nextRun === '-1') {
    nextRunConverted = 'N/A'
  } else {
    if (program.nextRun) {
      var date = new Date(program.nextRun)
      nextRunConverted = date.toString().slice(4, 21)
    }
  }

  Object.assign(program, {
    NextRunConverted: nextRunConverted,
    Configured: setConfigAndManRunnFlag(program),
    ManRunnable: setConfigAndManRunnFlag(program),
    Active: setActiveFlag(program),
    AutoRunnable: setAutoRunnableFlag(program),
    Message: ''
  })
}